// Takes a calculated aspect ratio (width/height, e.g 16/9 for standard widescreen), or separate width and height params
export const aspectRatioPadding = ({ aspectRatio, height, width }) => {
  const paddingRatio = (1 / aspectRatio) || (height / width);

  return `${(paddingRatio * 100).toPrecision(4)}%`;
};

export const clamp = (min, val, max) => Math.min(Math.max(min, val), max);
